
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import PartnershipRequest from "@components/SubmitRealEstate/PartnershipRequest";
import ProvideAreal from "@components/SubmitRealEstate/ProvideAreal";
import RealEstateDevelop from "@components/SubmitRealEstate/RealEstateDevelop";
import { Box } from "@mui/material";
import useTranslation from "next-translate/useTranslation";
import { useCallback, useEffect, useMemo, useState } from "react";
import { buildClass } from "@utils/tag";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "noval";
import { addStatusQuery } from "@utils/addStatusQuery";
import Tabs from "@components/InvestmentCalculator/Tabs";
import RenderMeta from "@utils/RenderMeta";
import SelectBase from "@components/select/Select";
import { useQuery } from "@tanstack/react-query";
import { http } from "@network/http";
import { removeSpecificQueryParams } from "@utils/removeQueries";
import { Text } from "@utils/helper";
const components = {
    1: ProvideAreal,
    2: RealEstateDevelop,
    3: PartnershipRequest
};
const getServerSideProps = async (context) => {
    const { addHeaders, serverSideHttp } = await import("@network/http");
    const realEstateOptions = await serverSideHttp.get(`/real-estate-get-selected-values`, addHeaders(context.locale));
    return {
        props: {
            initialRealEstateOptions: realEstateOptions?.data?.data || {}
        }
    };
};
const SubmitOpportunities = ({ initialRealEstateOptions }) => {
    const router = useRouter();
    const { t, lang } = useTranslation("submit-opportunities");
    const { dispatch, dirty } = useDispatch();
    const [mountedTimes, setMountedTimes] = useState(0);
    const [value, screen, RealEstateType] = useSelector(["opportunities.activeTab", "screen", "enums.RealEstateType"], [
        +router.query.tab && +router.query.tab >= 1 && +router.query.tab <= 3
            ? +router.query.tab
            : 1,
    ]);
    const isMobile = ["sm-phone", "phone"].includes(screen);
    const handleChangeTab = useCallback((current) => {
        dispatch(({ state, update }) => {
            update({ activeTab: current }, "opportunities");
            const isApp = state?.opportunities?.isApp === "true";
            const queries = { tab: current };
            if (isApp)
                queries.app = "true";
            addStatusQuery(router, queries);
        });
    }, []);
    const CurrentPage = useMemo(() => components[value], [value]);
    useEffect(() => {
        const isApp = router.query?.app === "true";
        dispatch({ isApp: isApp ? "true" : "null" }, "opportunities");
        if ((+router.query.tab && +router.query.tab < 1) || +router.query.tab > 3) {
            removeSpecificQueryParams(["tab"], router);
        }
        return () => dirty("opportunities");
    }, [router.query]);
    const { data: RealEstateOptions, refetch } = useQuery({
        queryKey: ["RealEstateOptions", lang],
        queryFn: async () => http
            .get(`/real-estate-get-selected-values`)
            .then(({ data }) => data?.data),
        initialData: initialRealEstateOptions,
        enabled: mountedTimes >= 2
    });
    useEffect(() => {
        mountedTimes < 2 && setMountedTimes(mountedTimes + 1);
        if (mountedTimes >= 2) {
            refetch();
        }
    }, [lang]);
    return (<>
      <RenderMeta title={`${t("header")} | ${t("common-locale:aseel")}`} description="" img={"/images/ogi/home.jpg"}/>
      <div>
        <Box className="bg-[#F8FBFF] text-black">
          <div className="base-container">
            <Box className="relative py-[56px]">
              <div className="flex flex-col items-start justify-center gap-10">
                <div className={buildClass("flex flex-col w-full rounded-[10px] overflow-hidden gap-[18px]", "relative shadow-md border-t-8 border-t-[#2B64F5] p-10 pt-7")}>
                  <div />
                  <Text color="#333333" className="!text-base sm:!text-4xl" fontType="Expo_bld" weight={500}>
                    {t("header")}
                  </Text>
                </div>
                <div className="flex flex-col w-full m-auto relative gap-10">
                  {!isMobile ? (<Tabs tabs={RealEstateType} value={value} handleChangeTab={handleChangeTab}/>) : (<div className="h-fit pb-3">
                      <SelectBase id="submit-opportunities-select" selected={value} handleChange={(e) => handleChangeTab(e.target.value)} placeholder={t("select_place")} list={RealEstateType?.map((tab) => ({
                value: tab.value,
                title: tab.label
            }))} itemClass="mx-5 h-[25px] text-[14px]" selectWidth={isMobile ? "100%" : "350px"} selectBg="transparent" borderBottom border/>
                    </div>)}
                  <CurrentPage RealEstateOptions={RealEstateOptions}/>
                </div>
              </div>
            </Box>
          </div>
        </Box>
      </div>
    </>);
};
export default SubmitOpportunities;

    async function __Next_Translate__getServerSideProps__19676fb3756__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/submit-opportunities',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__19676fb3756__ as getServerSideProps }
  